import {
  Indicator,
  Information,
  PartialBy,
  UpdateIndicator,
  IndicatorBase,
  LayerProperties,
} from "../types";
import {
  IndicatorLayersResponse,
  InformationResponse,
  IndicatorBaseResponse,
} from "types/backend";

import {
  deserializeLayer,
  deserializeLayerBase,
  serializeLayer,
} from "./LayerUtils";

export function serializeIndicator(
  data: PartialBy<Indicator, "id"> | UpdateIndicator
): PartialBy<IndicatorLayersResponse, "id"> {
  const { id, image, layers, tags, groupingKey, information, ...rest } = data;

  const serializedIndicator: PartialBy<IndicatorLayersResponse, "id"> = {
    ...rest,
    imageUrl: image,
    groupingKey: groupingKey || null,
    indicatorInformation: serializeIndicatorInformation(information),
    tags: tags.map((tag) => ({ name: tag })),
    //@ts-ignore
    layers: layers.map(serializeLayer),
  };
  if (id) {
    serializedIndicator.id = id;
  }
  return serializedIndicator;
}

function serializeIndicatorInformation(
  information: Information[]
): InformationResponse[] {
  return information.reduce(
    (updated: InformationResponse[], current: Information) => {
      if (current && current.label && current.value)
        return [
          ...updated,
          { name: current.label, value: current.value, order: updated.length },
        ];
      return [...updated];
    },
    []
  );
}

export function deserializeIndicatorBase(
  data: IndicatorBaseResponse,
  layerProperties: LayerProperties[]
): IndicatorBase {
  const { imageUrl, attribution, layers, tags, indicatorInformation, ...rest } =
    data;

  return {
    ...rest,
    image: imageUrl || "",
    attribution: attribution || "",
    information: deserializeIndicatorInformation(indicatorInformation || []),
    tags: (tags || []).map((tag) => tag.name),
    layers: layers
      ? layers.map((layer) => deserializeLayerBase(layer, layerProperties))
      : [],
  };
}

export function deserializeIndicator(
  data: IndicatorLayersResponse,
  layerProperties: LayerProperties[]
): Indicator {
  const {
    imageUrl,
    layers,
    tags,
    attribution,
    groupingKey,
    indicatorInformation,
    ...rest
  } = data;

  return {
    ...rest,
    image: imageUrl || "",
    attribution: attribution || "",
    groupingKey: groupingKey || "",
    information: deserializeIndicatorInformation(indicatorInformation || []),
    tags: (tags || []).map((tag) => tag.name),
    layers: layers
      ? layers.map((layer) => deserializeLayer(layer, layerProperties))
      : [],
  };
}

function deserializeIndicatorInformation(
  information: InformationResponse[]
): Information[] {
  return information.reduce(
    (updated: Information[], current: InformationResponse) => {
      if (current && current.name && current.value)
        return [...updated, { label: current.name, value: current.value }];
      return [...updated];
    },
    []
  );
}
